import { render } from "./NewArticle.vue?vue&type=template&id=7968696e&scoped=true"
import script from "./NewArticle.vue?vue&type=script&lang=js"
export * from "./NewArticle.vue?vue&type=script&lang=js"

import "./NewArticle.vue?vue&type=style&index=0&id=7968696e&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7968696e"]])

export default __exports__